<aumico-annualReport-cash-flow-operating-activities-component
    #operatingActivities
    [isSavedClick]="isSavedClicked"
    [operatingActivities]="operatingActivitiesData"
    [updateFlisAutomatically]="updateFlisAutomatically"
    [savedOperatingActivities]="savedOperatingActivitiesData"
    [reportLocale]="reportLocale"
    (totalChangeEvent)="onOperatingActivitiesTotalChange($event)"
    [autofillApplied]="autofillApplied"
>
</aumico-annualReport-cash-flow-operating-activities-component>

<aumico-annualReport-cash-flow-investing-activities-component
    #investingActivities
    [investingActivities]="investingActivitiesData"
    [updateFlisAutomatically]="updateFlisAutomatically"
    [savedInvestingActivities]="savedInvestingActivitiesData"
    [reportLocale]="reportLocale"
    (totalChangeEvent)="onInvestingActivitiesTotalChange($event)"
    (tableValidity)="onInvestingActivitiesValidityChange($event)"
>
</aumico-annualReport-cash-flow-investing-activities-component>

<aumico-annualReport-cash-flow-financing-activities-component
    #financingActivities
    [financingActivities]="financingActivitiesData"
    [updateFlisAutomatically]="updateFlisAutomatically"
    [savedFinancingActivities]="savedFinancingActivitiesData"
    [reportLocale]="reportLocale"
    (totalChangeEvent)="onFinancingActivitiesTotalChange($event)"
>
</aumico-annualReport-cash-flow-financing-activities-component>

<aumico-annualReport-cash-flow-total-from-activities-component
    #totalFromActivities
    [currentTotal]="currentTotal"
    [previousTotal]="previousTotal"
    [savedTotal]="savedTotalData"
    [reportLocale]="reportLocale"
    [operatingCurrent]="operatingActivitiesCurrentTotal"
    [operatingPrevious]="operatingActivitiesPreviousTotal"
    [investingCurrent]="investingActivitiesCurrentTotal"
    [investingPrevious]="investingActivitiesPreviousTotal"
    [financingCurrent]="financingActivitiesCurrentTotal"
    [financingPrevious]="financingActivitiesPreviousTotal">
</aumico-annualReport-cash-flow-total-from-activities-component>

<aumico-annualReport-cash-flow-total-component
    #total
    [total]="totalData"
    [savedTotal]="savedTotalData"
    [reportLocale]="reportLocale"
    [updateFlisAutomatically]="updateFlisAutomatically"
    [previousTotalCaptions]="previousTotalCaptions"
    (differenceInTotal)="onDifferenceInTotal($event)"
>
</aumico-annualReport-cash-flow-total-component>
